<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Empresa
              </div>
            </div>
            <hr style="margin-top: -4px">
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="Name">
                      <span class="required">*</span> Nome da empresa:
                    </label>
                    <input
                      id="Name"
                      v-model="company.company_name"
                      autocomplete="new-password"
                      type="text"
                      class="form-control"
                      placeholder=""
                    >
                  </div>
                  <div class="form-group col-md-3">
                    <label
                      for="Cnpj"
                    ><span class="required">*</span> CNPJ:
                    </label>
                    <input
                      id="Cnpj"
                      v-model="company.cnpj"
                      v-mask="'99.999.999/9999-99'"
                      autocomplete="new-password"
                      class="form-control"
                      placeholder=""
                      type="text"
                    >
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Email">
                      <span class="required">*</span> Email:
                    </label>
                    <input
                      id="Email"
                      v-model="company.email"
                      autocomplete="new-password"
                      class="form-control"
                      placeholder=""
                      type="email"
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-2">
                    <label><span class="required">*</span> CEP</label>
                    <input
                      v-model="company.cep"
                      v-mask="'99999-999'"
                      type="tel"
                      class="form-control"
                      @keyup="buscar"
                    >
                  </div>
                  <div class="form-group col-md-5">
                    <label><span class="required">*</span> Logradouro</label>
                    <input
                      v-model="company.street"
                      type="text"
                      class="form-control"
                    >
                  </div>
                  <div class="form-group col-md-2">
                    <label><span class="required">*</span> Número</label>
                    <input
                      id="inputNumero"
                      v-model="company.number"
                      type="text"
                      class="form-control"
                      inputmode="numeric"
                      maxlength="10"
                      placeholder="Somente números ou S/N"
                      @input="normalizarNumero"
                    >
                  </div>
                  <div class="form-group col-md-3">
                    <label><span class="required">*</span> Baírro</label>
                    <input
                      v-model="company.neighborhood"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-2">
                    <label><span class="required">*</span> Estado</label>
                    <input
                      v-model="company.state"
                      type="text"
                      class="form-control"
                    >
                  </div>
                  <div class="form-group col-md-5">
                    <label><span class="required">*</span> Cidade</label>
                    <input
                      v-model="company.city"
                      type="text"
                      class="form-control"
                    >
                  </div>
                  <div class="form-group col-md-5">
                    <label>Complemento</label>
                    <input
                      v-model="company.complement"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label><span class="required">*</span> País</label>
                    <v-select
                      v-model="company.country"
                      :options="countries"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputUser">
                      <span class="required">*</span> Status:
                    </label>
                    <select
                      v-model="company.status"
                      class="form-control"
                    >
                      <option :value="1">
                        Ativo
                      </option>
                      <option :value="0">
                        Inativo
                      </option>
                    </select>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link
                    to="/companies"
                    class="btn btn-back"
                  >
                    <i class="fa fa-arrow-left" /> Voltar
                  </router-link>
                  <a
                    class="btn btn-add ml-1"
                    @click="save"
                  >
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { isValidEmail, normalizeAddressNumber, stripFlagEmoji } from '@/utils/validators'
import { apiErrorMessage } from '@/utils/apiError'
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  name: 'ImageUpload',
  components: {
    BaseCrud,
    vSelect,
  },
  data() {
    return {
      company: {
        company_name: '',
        cnpj: '',
        email: '',
        cep: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: '',
        status: '',
      },
      countries: [],
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const self = this
    const { id } = self.$route.params

    self.buscarPaises()

    if (id) {
      self.getCompany(id)
    }
  },
  methods: {
    buscarPaises() {
      const self = this
      const api = `${self.$store.state.api}lookup/countries`

      axios
        .get(api)
        .then(response => {
          self.countries = response.data.data
        })
        .catch(error => {
          console.error('Erro ao obter a lista de países', error)
          self.countries = ['Brasil']
          self.$message(
            'Atenção',
            'Não foi possível carregar a lista de países.',
            'warning',
          )
        })
    },

    normalizarNumero() {
      this.company.number = normalizeAddressNumber(this.company.number)
    },

    validarFormulario() {
      if (!isValidEmail(this.company.email)) {
        this.$message('Erro', 'Informe um e-mail válido.', 'error')
        return false
      }

      if (!this.company.country) {
        this.$message('Erro', 'Selecione um país.', 'error')
        return false
      }

      return true
    },

    save() {
      const self = this

      if (!self.validarFormulario()) return

      let api = `${self.$store.state.api}companies`

      if (self.company.id) {
        api += `/${self.company.id}`
        self.company._method = 'PUT'
      }

      axios
        .post(api, self.company)
        .then(response => {
          self.$message(
            'Sucesso',
            'Informações guardadas com sucesso',
            'success',
          )
          this.$router.push('/companies')
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    buscar() {
      const self = this

      self.naoLocalizado = false

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.company.cep)) {
        $.getJSON(
          `https://viacep.com.br/ws/${this.company.cep}/json/`,
          endereco => {
            if (endereco.erro) {
              self.endereco = {}
              $('#inputNumero').focus()
              self.naoLocalizado = true
              return
            }
            self.endereco = endereco
            self.company.street = self.endereco.logradouro
            self.company.neighborhood = self.endereco.bairro
            self.company.state = self.endereco.uf
            self.company.city = self.endereco.localidade
            $('#inputNumero').focus()
          },
        )
      }
    },
    getCompany(id) {
      const self = this
      const api = `${self.$store.state.api}companies/${id}`

      axios
        .get(api)
        .then(response => {
          self.company = response.data.data[0]
          self.company.country = stripFlagEmoji(self.company.country)
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
  },
}
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
